import { createSlice, current } from '@reduxjs/toolkit';

const initialAccountState = {
  account: {},
  accountList: { list: [], cursor_id: '' },
};

const accountSlice = createSlice({
  name: 'accountData',
  initialState: initialAccountState,
  reducers: {
    updateAccountData(state, { payload }) {
      state.account = payload;
    },
    updateAccountList(state, { payload }) {
      state.accountList = payload;
    },
    clearAccount: () => initialAccountState,
    clearAccountList(state) {
      state.accountList = { list: [], cursor_id: '' };
    },
  },
});

export const { updateAccountData, clearAccount, updateAccountList, clearAccountList } =
  accountSlice.actions;
export default accountSlice.reducer;
